import { apiSlice } from "../../../_api/apiSlice";

export const permissionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllPermissions: builder.query({
      query: (params) => ({
        url: "/permission",
        method: "GET",
        params,
      }),
      providesTags: ["Permissions"],
    }),
    getPermissionsFilters: builder.mutation({
      query: () => ({
        url: "/data/getPermissionsFilters",
        method: "GET",
      }),
    }),
    getCurrentUserPermissions: builder.query({
      query: () => ({
        url: "/permission/currentUser",
        method: "GET",
      }),
      providesTags: ["CurrentUserPermissions"],
    }),
  }),
});

export const {
  useGetAllPermissionsQuery,
  useGetPermissionsFiltersMutation,
  useGetCurrentUserPermissionsQuery,
} = permissionApiSlice; 